import React from 'react';
import {Dialog, DialogProps} from '@material-ui/core';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';

import {ModalFooter, FooterButtonProps} from './components/footer/modal-footer';
import {ModalContent} from './components/modal-content';

export type DialogModalProps =
    & DialogProps
    & {
    showCloseButton?: boolean
    headerTitle?: string;
    buttons?: Array<FooterButtonProps>;
}

export const DialogModal = ({
    children, headerTitle, buttons, showCloseButton = true, ...restProps
}: DialogModalProps) => {
    return (
        <Dialog
            aria-labelledby={headerTitle}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500
            }}
            maxWidth={'md'}
            fullWidth={true}
            {...restProps}
        >
            <Fade in={restProps.open}>
                <>
                    <ModalContent showCloseButton={showCloseButton}
                        headerTitle={headerTitle}
                        onClose={restProps.onClose as any}>
                        {children}
                    </ModalContent>

                    {buttons ? <ModalFooter buttons={buttons}/> : null}
                </>
            </Fade>
        </Dialog>
    );
};
